// extracted by mini-css-extract-plugin
export default {"productGrid":"AZ-z","centerLink":"BZ-z","productSection":"CZ-z","item":"DZ-z","ctaButton":"EZ-z"};